import axios, { AxiosPromise } from 'axios';

import { IOrderRelatedData } from '../../../@types/model/order/orderRelatedData';

export default class OrderRelatedDataHttpService {
    public static getAllOrderRelatedData(loadMasterData ?: boolean) : AxiosPromise<IOrderRelatedData> {
        return axios.get(`${API_URL}/v1/Order/AllOrderRelatedData`, {
            params: { loadMasterData },
        });
    }
}
